export const getCurrentUser = () => {
  const userStr =
    localStorage.getItem("authUser") || sessionStorage.getItem("authUser");
  if (!userStr) return null;

  const user = JSON.parse(userStr);
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    role:user?.role,
    autoIncrementAccount: user.autoIncrementAccount,
    selectedBlock: user.selectedBlock,
    companyId: user.companyId,
  };
};
